import ProgressBar from "react-bootstrap/ProgressBar";

function RevenueCollectionFunnel({ chart_data }) {
  const total = chart_data?.[0];
  const total_issues = total?.total_invoice;

    let userLoging = {};
    let currencies = [];
    userLoging = JSON.parse(localStorage.getItem("user") || "{}");
    currencies = JSON.parse(localStorage.getItem("currency_rates") || "[]");
    const defaultCurrencyId = Number(userLoging?.default_currency_id || 1);
    const selectedCurrency = currencies.find(
    (currency) =>
      Number(currency.value) === defaultCurrencyId
  );
    const symbol = selectedCurrency?.symbol || (defaultCurrencyId === 1 ? "₹" : "");
    const currencyType = defaultCurrencyId === 1 ? "en-IN" : "en-US";
    const amountSuffix = defaultCurrencyId === 1 ? "Cr" : "K";

  return (
    <>
      <div className="justify-content-center">
        <p className="fs-15 fw-light mb-0 text-muted">
          Total Invoices added to PINE
          <span className="float-end fs-12 fw-normal">100%</span>
        </p>
        <ProgressBar
          className="custom-progress mb-2"
          max={100}
          variant={"info"}
          now={100}
          label={`${symbol} ${total?.total_invoice} ${amountSuffix}`}
        />

        <p className="fs-15 fw-light mb-0 text-muted">
          Invoices Issued / Sent
          <span className="float-end fs-12 fw-normal">
            {((total?.total_issued / total_issues) * 100).toFixed(2)}%
          </span>
        </p>
        <ProgressBar
          className="custom-progress mb-2"
          max={100}
          variant={"warning"}
          now={`${(total?.total_issued / total_issues) * 100}`}
          label={`${symbol} ${total?.total_issued} ${amountSuffix}`}
        />

        <p className="fs-15 fw-light mb-0 text-muted">
          Amount Collected
          <span className="float-end fs-12 fw-normal">
            {((total?.total_collected / total_issues) * 100).toFixed(2)}%
          </span>
        </p>
        <ProgressBar
          className="custom-progress mb-2"
          max={100}
          variant={"success"}
          now={`${(total?.total_collected / total_issues) * 100}`}
          label={`${symbol} ${total?.total_collected} ${amountSuffix}`}
        />

        <p className="fs-15 fw-light mb-0 text-muted">
          To Be Received
          <span className="float-end fs-12 fw-normal">
            {((total?.not_received / total_issues) * 100).toFixed(2)}%
          </span>
        </p>
        <ProgressBar
          className="custom-progress mb-2"
          max={100}
          variant={"secondary"}
          now={`${(total?.not_received / total_issues) * 100}`}
          label={`${symbol} ${total?.not_received} ${amountSuffix}`}
        />
      </div>
    </>
  );
}

export default RevenueCollectionFunnel;
